export default __webpack_public_path__ + "static/media/pending.9499d3a5.svg";